module.exports = __webpack_public_path__ + "media/y682.9e754922.mp3";